export const signUpIndividualSteps = [
    {
        key: "account",
        title: "Account Information",
        description: "Details about the main account",
    },
    {
        key: "personal",
        title: "Personal Information",
        description: "Details about you",
    },
    {
        key: "review",
        title: "Review Information",
        description: "Review your information before submitting",
    },
];

export const workAsIndividual = [
    "W2 - Employee",
    "Subcontractor",
    "Both",
]

export const workIndustryIndividual = [
    "Cleaning Services",
    "Painting Services",
    "Landscaping Services",
]